<template>
    <div class="cb-group" @click="updateBox(value, id)">
        <checkbox :value="toggle" :toggle-check="true" :id="id" />
        <labelc type="header" class="wide-label" :text="text"
                :styleText="{marginLeft: '10px'}"/>
    </div>
</template>

<script>
export default {
    name: 'checkboxgroup',
    data() {
        return {
            toggle: Boolean,
        }
    },
    created() {
        this.toggle = this.value;
    },
    props: {
        value: Boolean,
        text: String,
        id: String,
        toggleBoolean: {
            type: Function,
            required: false
        },
    },
    methods: {
        updateBox(value, id) {
            this.toggle = !this.toggle;

            if (this.toggleBoolean) {
                this.toggleBoolean(value, id);
            }
            else {
                this.$emit('toggle', value);
            }
        },
    }
}
</script>

<style scoped>
.cb-group {
    display: flex;
    padding-top: 15px;
    padding-bottom: 15px;
}

.md-card-select .wide-label {
    width: 400px;
}

.toggle-checkbox {
    height: 20px;
    align-self: center;
}
</style>
